"use client"

const BackButton = () => {
  return (
    <button 
      onClick={() => window.history.back()}
      className="text-sm text-black hover:text-gray-600 transition-colors flex items-center gap-2"
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
      </svg>
      Volver
    </button>
  )
}

export default BackButton
